/* ZeroNic, product page interactions: gallery, variant selection, quantity.
   Ported from the inline scripts in product.html / flavors.html, rewired to
   real Shopify variants. */
(function () {
  'use strict';

  function $(s, c) {
    return (c || document).querySelector(s);
  }
  function $all(s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  }

  var pdp = $('[data-zn-pdp]');
  if (!pdp) return;

  var variants = [];
  var raw = $('[data-pdp-variants]');
  if (raw) {
    try {
      variants = JSON.parse(raw.textContent) || [];
    } catch (e) {
      variants = [];
    }
  }

  var mainImg = $('[data-pdp-main]', pdp);
  var priceEl = $('[data-pdp-price]', pdp);
  var variantInput = $('[data-pdp-variant-input]', pdp);
  var submitBtn = $('[data-pdp-submit]', pdp);

  function swapImage(src, alt) {
    if (!mainImg || !src) return;
    mainImg.style.opacity = '0';
    var next = new Image();
    next.onload = function () {
      mainImg.src = src;
      if (alt) mainImg.alt = alt;
      mainImg.style.opacity = '1';
    };
    next.onerror = function () {
      mainImg.style.opacity = '1';
    };
    next.src = src;
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl && variant.formattedPrice) priceEl.textContent = variant.formattedPrice;
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.getAttribute('data-label') || submitBtn.textContent
        : 'Sold out';
    }
    // Keep the URL shareable, like Shopify's own PDPs.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* Price comes back from Liquid already formatted for the default variant.
     For other variants we format from cents using the same shape as the first. */
  var priceTemplate = priceEl ? priceEl.textContent.trim() : '';
  function formatLike(cents) {
    var symbolMatch = priceTemplate.match(/^[^\d]*/);
    var symbol = symbolMatch ? symbolMatch[0] : '';
    var amount = cents / 100;
    var str =
      amount % 1 === 0
        ? amount.toLocaleString('en-ZA')
        : amount.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return symbol + str;
  }

  variants.forEach(function (v) {
    v.formattedPrice = formatLike(v.price);
  });

  if (submitBtn) submitBtn.setAttribute('data-label', submitBtn.textContent.trim());

  /* ---------- thumbnails (device PDP) ---------- */
  $all('[data-pdp-thumb]', pdp).forEach(function (btn) {
    btn.addEventListener('click', function () {
      $all('[data-pdp-thumb]', pdp).forEach(function (b) {
        b.classList.remove('border-clay');
        b.classList.add('border-transparent');
      });
      btn.classList.remove('border-transparent');
      btn.classList.add('border-clay');
      swapImage(btn.getAttribute('data-img'), btn.getAttribute('data-alt'));
    });
  });

  /* ---------- option buttons (device PDP: one group per option) ---------- */
  var optionButtons = $all('[data-pdp-option]', pdp);
  if (optionButtons.length) {
    var selected = {};
    optionButtons.forEach(function (btn) {
      if (btn.getAttribute('aria-checked') === 'true') {
        selected[btn.getAttribute('data-pdp-option')] = btn.getAttribute('data-value');
      }
    });

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-pdp-option');
        selected[group] = btn.getAttribute('data-value');

        optionButtons.forEach(function (b) {
          if (b.getAttribute('data-pdp-option') !== group) return;
          var on = b === btn;
          b.setAttribute('aria-checked', String(on));
          b.classList.toggle('border-clay', on);
          b.classList.toggle('border-ink/10', !on);
        });

        var label = $('[data-pdp-option-label="' + group + '"]', pdp);
        if (label) label.textContent = selected[group];

        var wanted = Object.keys(selected)
          .sort()
          .map(function (k) {
            return selected[k];
          });
        var match = variants.filter(function (v) {
          return wanted.every(function (val, i) {
            return v.options[i] === val;
          });
        })[0];

        if (match) {
          applyVariant(match);
          if (match.featured_image && match.featured_image.src) {
            swapImage(match.featured_image.src, match.featured_image.alt || '');
          }
        }
      });
    });
  }

  /* ---------- flavor options (flavor PDP) ---------- */
  var flavorButtons = $all('[data-flavor-opt]', pdp);
  if (flavorButtons.length) {
    var stage = $('[data-flavor-stage]', pdp);
    var nameEl = $('[data-flavor-name]', pdp);
    var notesEl = $('[data-flavor-notes]', pdp);

    flavorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        flavorButtons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-checked', String(on));
          b.classList.toggle('border-clay', on);
          b.classList.toggle('border-ink/10', !on);
        });

        var value = btn.getAttribute('data-value');
        if (nameEl) nameEl.textContent = value;
        if (notesEl) notesEl.textContent = btn.getAttribute('data-notes') || '';
        if (stage) stage.style.background = btn.getAttribute('data-bg') || '';
        swapImage(btn.getAttribute('data-img'), btn.getAttribute('data-alt'));

        var match = variants.filter(function (v) {
          return v.title === value || v.options.indexOf(value) !== -1;
        })[0];
        if (match) applyVariant(match);
      });
    });
  }

  /* ---------- pack size options (Cores Pack PDP) ---------- */
  var packButtons = $all('[data-cores-opt]', pdp);
  if (packButtons.length) {
    var stageEl = $('[data-cores-stage]', pdp);

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        packButtons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-checked', String(on));
          b.classList.toggle('border-clay', on);
          b.classList.toggle('border-ink/10', !on);
        });

        if (stageEl) stageEl.style.background = btn.getAttribute('data-bg') || '';

        // Price is rendered by Liquid on each option, so reuse it rather than
        // reformatting from cents.
        var priceText = btn.getAttribute('data-price');
        if (priceEl && priceText) priceEl.textContent = priceText;

        var id = btn.getAttribute('data-variant');
        var match = variants.filter(function (v) {
          return String(v.id) === String(id);
        })[0];
        if (match) {
          if (variantInput) variantInput.value = match.id;
          if (submitBtn) {
            submitBtn.disabled = !match.available;
            submitBtn.textContent = match.available
              ? submitBtn.getAttribute('data-label') || submitBtn.textContent
              : 'Sold out';
          }
          if (window.history && window.history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', u);
          }
        }
      });
    });
  }


  /* ---------- step dropdowns: hover-to-open where opted in ---------- */
  $all('[data-step-drop][data-open-on-hover]', pdp).forEach(function (d) {
    var summary = d.querySelector('summary');
    if (!summary) return;
    // Hover is an enhancement only; click still works, and touch devices
    // (which never fire mouseenter) fall back to click alone.
    if (!window.matchMedia('(hover: hover)').matches) return;
    d.addEventListener('mouseenter', function () {
      d.open = true;
    });
  });

  /* ---------- Ritual bundle step builder ---------- */
  var step1Buttons = $all('[data-step1-opt]', pdp);
  if (step1Buttons.length) {
    var addonToggle = $('[data-addon-toggle]', pdp);
    var addonInput = $('[data-addon-input]', pdp);
    var addonQty = $('[data-addon-qty]', pdp);

    step1Buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        step1Buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-checked', String(on));
          b.classList.toggle('border-clay', on);
          b.classList.toggle('border-ink/10', !on);
          var state = b.querySelector('[data-step1-state]');
          if (state) {
            state.textContent = on ? 'Selected' : 'Select';
            state.classList.toggle('text-clay', on);
            state.classList.toggle('text-ink-muted', !on);
          }
        });

        var id = btn.getAttribute('data-variant');
        if (id && variantInput) variantInput.value = id;

        var priceText = btn.getAttribute('data-price');
        if (priceEl && priceText) priceEl.textContent = priceText;

        var match = variants.filter(function (v) { return String(v.id) === String(id); })[0];
        if (match && submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available
            ? submitBtn.getAttribute('data-label') || submitBtn.textContent
            : 'Sold out';
        }
        if (id && window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          window.history.replaceState({}, '', u);
        }
      });
    });

    // Disabled inputs are not submitted, so the add-on only joins the cart
    // payload when the box is ticked.
    if (addonToggle && addonInput) {
      addonToggle.addEventListener('change', function () {
        addonInput.disabled = !addonToggle.checked;
        if (addonQty) addonQty.disabled = !addonToggle.checked;
      });
    }
  }


  /* ---------- cores add-on: pick exactly N of the flavours ---------- */
  var coresBox = $('[data-cores-addon]', pdp);
  if (coresBox) {
    var max = parseInt(coresBox.getAttribute('data-max'), 10) || 3;
    var toggle = $('[data-cores-toggle]', coresBox);
    var picker = $('[data-cores-picker]', coresBox);
    var countEl = $('[data-cores-count]', coresBox);
    var idInput = $('[data-cores-input]', coresBox);
    var qtyInput2 = $('[data-cores-qty]', coresBox);
    var propsInput = $('[data-cores-props]', coresBox);
    var opts = $all('[data-core-option]', coresBox);

    function chosen() {
      return opts.filter(function (o) { return o.checked; }).map(function (o) { return o.value; });
    }

    function sync() {
      var picks = chosen();
      var on = !!(toggle && toggle.checked);
      var complete = on && picks.length === max;

      if (countEl) countEl.textContent = picks.length + '/' + max;

      // Cap the selection: once N are picked the rest go disabled.
      opts.forEach(function (o) {
        o.disabled = !o.checked && picks.length >= max;
      });

      // The add-on only joins the cart payload when it is switched on AND the
      // full set is chosen, so a half-filled pack can never be ordered.
      if (idInput) idInput.disabled = !complete;
      if (qtyInput2) qtyInput2.disabled = !complete;
      if (propsInput) {
        propsInput.disabled = !complete;
        propsInput.value = picks.join(', ');
      }

      if (submitBtn) {
        var blocked = on && !complete;
        submitBtn.disabled = blocked;
        submitBtn.textContent = blocked
          ? 'Choose ' + (max - picks.length) + ' more'
          : submitBtn.getAttribute('data-label') || submitBtn.textContent;
      }
    }

    if (toggle) {
      toggle.addEventListener('change', function () {
        if (picker) picker.hidden = !toggle.checked;
        if (!toggle.checked) opts.forEach(function (o) { o.checked = false; });
        sync();
      });
    }
    opts.forEach(function (o) { o.addEventListener('change', sync); });
    sync();
  }

  /* ---------- quantity ---------- */
  var qtyDisplay = $('[data-qty-display]', pdp);
  var qtyInput = $('[data-qty-input]', pdp);
  var qty = 1;

  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }

  var dec = $('[data-qty-dec]', pdp);
  var inc = $('[data-qty-inc]', pdp);
  if (dec) dec.addEventListener('click', function () { setQty(qty - 1); });
  if (inc) inc.addEventListener('click', function () { setQty(qty + 1); });
})();
